import { RootState } from '../index'

export const selectTerminals = (state: RootState) => state.terminals.terminals
